
     <div class="dismiss_div">
      <ion-icon (click)="dismissSlider()" class="full-image" name="close" style="font-size: 24px;border-radius: 50%;background: white;color:#007382 ;"></ion-icon>
    </div> 
    <div (click)="arrow_left()" id="arrow-left" class="arrow arrowleft_icon">
      <img style="width: 23px !important;
      height: 23px !important;
      margin: 0px !important;" src="assets/img/menu_icons/arrow_back.svg" />
     </div>
     <swiper-container  [modules]="swiperModules" [options]="zoomOption">
      <swiper-slide *ngFor="let item of imagesList">
          <img class="slide" [src]="item" />
          <div  type="submit" class="submit-enable delete_btn" (click)="removeSelectedImage(item)"> 
            <ion-icon name="trash-outline" class="trashIcon" ></ion-icon>
          </div> 
      </swiper-slide>
    </swiper-container> 
    <div (click)="arrow_right()" id="arrow-right" class="arrow arrowleft_icon">
        <img style="width: 23px !important;
        height: 23px !important;
        margin: 0px !important;" src="assets/img/menu_icons/arrow_forward.svg" />
     </div>
   




